<div class="dropdown-checkbox" [class.open]="isOpen">
  <button
    type="button"
    class="dropdown-checkbox-toggle"
    (click)="toggleDropdown()"
    [disabled]="loading || disabled"
  >
    <ng-container>
      <div #displayContainer class="selected-values">
        @for (label of visibleLabels; track label; let last = $last) {
          @if (label.image) {
            <img [src]="label.image" class="image" />
          }
          <span class="label-item">{{ label.name }}</span>
        }
        @if (hiddenCount > 0) {
          <span class="more-count">+{{ hiddenCount }}</span>
        }
      </div>
      <span class="arrow" [class.up]="isOpen"></span>
    </ng-container>
    @if (loading) {
      <span class="spinner">
        <app-loading></app-loading>
      </span>
    }
  </button>

  @if (isOpen) {
    <div
      class="dropdown-checkbox-menu"
      #menuContainer
      (scroll)="onMenuScroll()"
    >
      <!-- scanner-disable-next-line R6 -- live filter box of the dropdown, native by design (WAP-1568) -->
      <input
        type="text"
        class="filter-input"
        #filterInput
        [formControl]="filterControl"
        placeholder="{{ 'dropdown-checkbox.input.placeholder' | translate }}"
      />
      <sui-checkbox
        class="dropdown-item"
        indicatorPosition="trailing"
        [checked]="allSelected()"
        (checkedChange)="onToggleAll($event)"
      >
        {{ "dropdown-checkbox.label.select-all" | translate }}
      </sui-checkbox>
      <div class="divider"></div>
      @for (opt of displayedOptions; track opt) {
        <sui-checkbox
          class="dropdown-item"
          indicatorPosition="trailing"
          [checked]="isSelected(opt)"
          (checkedChange)="onToggleOption(opt, $event)"
        >
          @if (opt.image) {
            <img [src]="opt.image" class="image" />
          }
          <span [innerHTML]="opt.name | highlight: filterText"></span>
        </sui-checkbox>
      }
      <!-- Optional paging footer -->
      @if (hasMore) {
        <div class="infinite-footer">
          {{ "dropdown-checkbox.label.loading-more" | translate }}
        </div>
      }
      @if (!hasMore && displayedOptions?.length) {
        <div class="infinite-footer done">
          {{ "dropdown-checkbox.label.no-more-items" | translate }}
        </div>
      }
    </div>
  }
</div>
